var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphoneS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 15.9422H13.25C13.25 15.9422 13.0552 15.7461 12.75 15.4578C12.1348 14.8767 11.071 13.9211 10.25 13.4422C8.64061 12.5034 8.25 12.4422 5.25 12.4422H4.75V15.9422H3.25V12.4068C1.55385 12.1641 0.25 10.7054 0.25 8.9422C0.25 7.0092 1.817 5.4422 3.75 5.4422H5.25C8.25 5.4422 8.64641 5.37763 10.25 4.4422C11.0383 3.98235 12.124 3.00945 12.75 2.42214C13.0543 2.1366 13.25 1.9422 13.25 1.9422H14.25V2.94886V3.06257V3.4422V7.4422C15.0784 7.4422 15.75 8.11377 15.75 8.9422C15.75 9.77063 15.0784 10.4422 14.25 10.4422V14.4422V14.8212V14.9487V15.9422ZM11.0058 12.1465C11.5844 12.4841 12.2157 12.9817 12.75 13.4388V8.9422V4.43886C12.2103 4.90136 11.5721 5.40751 11.0058 5.73787C10.1761 6.22185 9.49637 6.58068 8.56397 6.76462C8.30975 6.81477 8.04099 6.85082 7.75 6.8767V11.007C8.03995 11.0327 8.3078 11.0685 8.56121 11.1184C9.49352 11.3019 10.1737 11.6612 11.0058 12.1465ZM5.25 6.9422C5.60909 6.9422 5.941 6.94157 6.25 6.93812V10.9461C5.94102 10.9428 5.60911 10.9422 5.25 10.9422H3.75C2.64543 10.9422 1.75 10.0468 1.75 8.9422C1.75 7.83763 2.64543 6.9422 3.75 6.9422H5.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphoneS);
export default __webpack_public_path__ + "static/media/megaphone-S.2c2dc6bf81c8012940be264537248973.svg";
export { ForwardRef as ReactComponent };